export enum Error {
  None,
  Partial,
  Generic
}
